import { isEmpty } from "lodash";
import { useEffect, useState } from "react";

import Carousel from "react-multi-carousel";

const ImageCarousel = (props) => {

    const [mediaItems, setMediaItems] = useState([]);

    const ButtonGroup = ({ next, previous, goToSlide, ...rest }: any) => {
        const { carouselState: { currentSlide } } = rest;
        return (
            <div className="carousel-button-group">
                <button className='prev-btn' onClick={() =>
                    previous()}> <i className="sprite"></i> </button>
                <button onClick={() => next()} className='next-btn' ><i className="sprite"></i></button>
            </div>

        );
    };

    useEffect(() => {
        if (!isEmpty(props.mediaItems)) {
            setMediaItems(props.mediaItems);
        }
    }, [props]);

    return (<>
        <Carousel
            // customRightArrow={<CustomRightArrow />}
            // customLeftArrow={<CustomLeftArrow />}
            ref={props.ref}
            customButtonGroup={<ButtonGroup />}
            additionalTransfrom={0}
            arrows={false}
            autoPlaySpeed={3000}
            autoPlay={true}
            centerMode={false}
            //className="pl-1 pr-1"
            containerClass={props.containerClass}
            dotListClass=""
            draggable={true}
            focusOnSelect={false}
            infinite
            itemClass=""
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={true}
            renderButtonGroupOutside={true}
            renderDotsOutside={false}
            responsive={{
                desktop: {
                    breakpoint: {
                        max: 3000,
                        min: 1024,
                    },
                    items: 1,
                },
                mobile: {
                    breakpoint: {
                        max: 464,
                        min: 0,
                    },
                    items: 1,
                },
                tablet: {
                    breakpoint: {
                        max: 1024,
                        min: 464,
                    },
                    items: 2,
                },
            }}
            rewind={true}
            rewindWithAnimation={true}
            rtl={false}
            shouldResetAutoplay
            showDots={false}
            sliderClass=""
            slidesToSlide={1}
            swipeable
        >
            {
                mediaItems && mediaItems.map((val, idx3) => {
                    return (<a
                        href="javascript:void(0)"
                        key={`cImage_${idx3}`}
                        rel="noreferrer"
                        {...(props.handleClick ? { onClick: (e) => { props.handleClick(e, idx3) } } : {})}
                    >
                        <img
                            src={val.type === 'Video' ? `${val.thumb}` : `${val.src}`}
                            key={""}
                            className="logistic-company-images"
                            style={{ maxWidth: "100%", height: "auto" }}
                            alt=""
                        />
                        {val.type === 'Video' &&
                        <span className="circle-play">
                            <i className="fa fa-solid fa-play"></i>
                        </span>
                        }
                    </a>)
                })
            }

        </Carousel >
    </>)
}

export default ImageCarousel;